// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Rounded Check icon.
 * @param {IconProps} props - The IconProps for the RoundedCheckIcon component.
 * @returns {ReactElement} The RoundedCheckIcon component.
 */
export const RoundedCheckIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon viewBox='0 0 15 12' color={color} id='rounded-check-icon' {...rest}>
      <path
        d='M13 2L5.4375 10L2 6.36364'
        stroke='currentColor'
        fill='transparent'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Icon>
  );
};
